<template>
<div id="app">
    <headers class="herderNav" ref="header" :isChange="false" />
  <div class="bkqdiv">
    <h1>联系我们</h1>
    <p class="bkq_contact">CONTACT US</p>
    <p>扫码添加小助手微信</p>
    <div class="bkqImg">
      <img id="bkqimg1" src="@/assets/rightNav/vico.jpg" />
      <img id="bkqimg2" src="@/assets/rightNav/zhushou.jpg" />
    </div>
  </div>
</div>
</template>
<script>
import headers from "../../components/header.vue";
export default {
  components: {
    headers,
  },
  mounted() {
    this.$refs.header.isTop = false;
    this.$refs.header.headerBack.background = "#ffffff";
    this.$refs.header.herderTits.color = "#666666";
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    this.$refs.header.loginButton = {
      background: "#618aff",
      color: "#fff",
    };
    this.$refs.header.phoneButton = {
      color: "#618aff",
      border: "1px solid #618aff",
    };
  },
  data() {
    return {
    };
  },
};
</script>
<style scoped>
@import'../../assets/css/forref.css';
</style>


// WEBPACK FOOTER //
// src/view/forref/forref.vue